module.exports = __webpack_public_path__ + "static/img/4.e0d0e75c.jpg";